import React from 'react';
import { useTranslation } from 'react-i18next';
import { NewCheckbox } from '../../../../../Components/PIM/common/NewCheckbox';

export function BorderConfig({ obj, handleBorder }) {
  const { t } = useTranslation('common');
  return (
    <div className="p-2">
      <p className="mb-2 f-14">{t('CUSTOM_MODULE.BORDER')}</p>
      <div className="checkbox-label">
        <NewCheckbox id="border" onChange={handleBorder} checked={obj?.otherConfiguration?.border === true} name="border" />
        <label htmlFor="border" className="chklabel">
          <span>{t('CUSTOM_MODULE.OUTLINE_BORDER')}</span>
        </label>
      </div>
      {obj?.otherConfiguration?.border === true && (
        <>
          <div className="checkbox-label mt-16">
            <NewCheckbox id="borderBottom" checked={obj?.otherConfiguration?.borderBottom === true} onChange={handleBorder} name="borderBottom" />
            <label htmlFor="borderBottom" className="chklabel">
              <span>Hide Border Bottom</span>
            </label>
          </div>
          <div className="checkbox-label mt-1">
            <NewCheckbox id="borderRight" checked={obj?.otherConfiguration?.borderRight === true} onChange={handleBorder} name="borderRight" />
            <label htmlFor="borderRight" className="chklabel">
              <span>Hide Border Right</span>
            </label>
          </div>
        </>
      )}
    </div>
  );
}

export default BorderConfig;
